<div class="popup-wrap2"
     (click)="onVoid($event)">

  <article class="popup-connect-box">

    <div class="connect-head">
      <div class="head-box">
        <div class="hun">{{ hanja }}</div>
        <div class="hun-eum-box" *ngIf="firstHun || hangul">
          <span class="hun-txt">{{ firstHun }}</span>
          <span class="eum-txt">{{ hangul }}</span>
        </div>
      </div>
    </div>

    <div class="connect-body"
         *ngIf="!IsLoading && listWord?.length > 0">
      <div class="hun-list">
        <div class="hun-box"
            *ngFor="let word of listWord">
          <app-word-disp class="word" #wordEl
                        [word]="word"
                        [style.min-width.px]="wordColumnMinWidth"></app-word-disp>
          <div class="word-list">
            <div class="word-box">{{ GetMeaning(word) }}</div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="IsLoading"
        class="connect-body">
      <div class="reload-icon">
        <img src="assets/img/loading_icon.gif">
      </div>
    </div>


    <div class="connect-body"
         *ngIf="errorTxt">
      <div class="error-txt">{{ errorTxt }}</div>
    </div>

    <div class="connect-body"
         *ngIf="hanjaWordInfo?.word_total_count === 0">
      <div class="error-txt">본 사전에서는 동자로 사용 되었습니다.</div>
    </div>

    <!-- div class="connect-body"
    *ngIf="getMoreTxt()" -->
    <div class="connect-tail">
      <div class="more-link-btn-box"
           *ngIf="!errorTxt && hanjaWordInfo?.word_total_count > 0">
        <a class="more-link-btn"
           (click)="onCloseMore($event)">{{ getLeftWordCount() > 0 ? '더 보기' : '자세히 보기' }}</a>
        <div *ngIf="getLeftWordCount() > 0"
             class="more-txt">{{ getMoreTxt() }}
        </div>
      </div>

      <div class="menu-box">
        <a class="close-btn"
           (click)="onClose($event)"></a>
      </div>

    </div>

  </article>
</div>
